import { CONSENT_STATUS_MESSAGES, ConsentStatusMessages } from "../consent-status.messages";

export type ChatContactListMessages = ConsentStatusMessages & {
  searchChatContactPlaceholder: string;
  addNewConversation: string;
  dialogTitle: string;
  searchContacts: string;
  robotLabel: string;
  attendantLabel: string;
  noChatsMessage: string;
  noChatsFound: string;
  startConversationSuccess: string;
  startConversationError: string;
  startConversationInactive: string;
  startingConversation: string;
  allChats: string;
  unreadChats: string;
  myConversationsTab: string;
  aiAgentsTab: string;
  openChats: string;
  awaitingClientChats: string;
  closedChats: string;
  attendingChats: string;
  loadMoreChats: string;
  loadingMoreChats: string;

};

export const CHAT_CONTACT_LIST_MESSAGES: ChatContactListMessages = {
  searchChatContactPlaceholder: "Buscar contato",
  addNewConversation: "Nova conversa",
  dialogTitle: "Nova Conversa",
  searchContacts: "Buscar conversa...",
  robotLabel: "Agente: ",
  attendantLabel: "Atendente: ",
  noChatsMessage: "Nenhum chat disponível, comece um novo chat.",
  noChatsFound: "Nenhum chat encontrado com o termo pesquisado.",
  startConversationSuccess: "Conversa iniciada com sucesso!",
  startConversationError: "Erro ao iniciar conversa",
  startConversationInactive: "Não é possível iniciar conversa com um contato inativo.",
  startingConversation: "Iniciando conversa...",
  allChats: "Todas",
  unreadChats: "Não lidas",
  myConversationsTab: "Minhas Conversas",
  aiAgentsTab: "Agentes de IA",
  openChats: "Abertas",
  awaitingClientChats: "Aguardando Cliente",
  closedChats: "Finalizadas",
  attendingChats: "Atendendo",
  loadMoreChats: "Carregar mais",
  loadingMoreChats: "Carregando...",


  ...CONSENT_STATUS_MESSAGES,
};
